<template>
    <div v-show="show" class="bg">
        <div class="box-container">
            <div class="title">
                <p>请选择发布平台</p>
                <img @click="close" src="../../assets/img/common/editPicClose.svg" alt="">
            </div>
            <div class="selected-container">
                <p class="title">已选：</p>
                <ul>
                    <!-- <li class="un"><span>看看新闻网：房产视频</span><img src="../../assets/img/common/editPicClose.svg" alt=""></li>
                    <li><span>看看新闻网：房产视频</span><img src="../../assets/img/common/editPicClose.svg" alt=""></li> -->
                    <li :class="{un: item.selected}" v-for="(item,index) in selectList" :key="index"><span :class="{un: item.no}">{{item.name}}</span><img v-if="!item.no" @click="del(item.column_key)" src="../../assets/img/common/editPicClose.svg" alt=""></li>
                </ul>
            </div>
            <div class="line"></div>
            <div class="select-container">
                <div class="left-container">
                    <div class="title">发布平台</div>
                    <ul>
                        <li v-for="(item,index) in list" @click="columnIndex=0;selectPlatformItem(item,index);" :class="{on: platformIndex == index}" :key="index">
                            <p :title="item.platform_title">{{item.platform_title}}</p>
                            <div>
                                <div v-click-outside="closePlatformAlertShow" v-if="item.is_expire" class="alert">
                                    <i @click="item.alertShow = !item.alertShow"></i>
                                    <div v-show="item.alertShow">账号异常，请<em @click="addCount(list[platformIndex].platform_key)">重新绑定</em></div>
                                </div>
                                <i></i>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="middle-container">
                    <div class="title">账号/栏目</div>
                    <ul>
                        <li :class="{on: columnIndex == index && item.isSelect}" @click="selectColumnItem(item,index)" v-for="(item,index) in list.length > 0 && list[platformIndex] && list[platformIndex].columns" :key="index">
                            <div :class="{grey: item.is_expire}">   
                                <i @click.stop="columnIndex = index;selectItem(item);" :class="{on: item.isSelect, un: item.selected, grey: item.is_expire}"></i>
                                <p @click.stop="columnIndex = index;selectItem(item);" :title="item.column_title">{{item.column_title}}</p>
                                <div v-click-outside="closeColumnAlertShow" v-if="item.is_expire" class="alert">
                                    <i @click.stop="item.alertShow = !item.alertShow"></i>
                                    <div v-show="item.alertShow">账号异常，请<em @click="addCount(list[platformIndex].platform_key)">重新绑定</em></div>
                                </div>
                            </div>
                            <i v-show="showThird" :class="{un: item.is_expire || item.selected}" @click.stop="columnIndex = index;selectItem(item);"></i>
                        </li>
                    </ul>
                </div>
                
                <div v-show="showThird" class="right-container">
                    <div class="title">稿件类型</div>
                    <ul>
                        <li v-if="showType" @click="selectTypeItem(item)" v-for="(item,index) in list.length > 0 && list[platformIndex] && list[platformIndex].columns && list[platformIndex].columns[columnIndex].content_type" :key="index">
                            <i :class="{on: item.selected}"></i>
                            <p :title="item.content_title">{{item.content_title}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btns-container">
                <p @click="createPlatform" class="btn on">确定</p>
                <p @click="close" class="btn">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "@common/common";
    import { apis } from "@common/config";
    import vClickOutside from "v-click-outside";

    export default {
        directives: {
            clickOutside: vClickOutside.directive
        },
        data() {
            return {
                show: true,
                showType: false,
                list: [],
                selectList: [],
                typeSelectList: [{
                    isSelect: false,
                    column_title: '视频稿'
                },{
                    isSelect: false,
                    column_title: '图文稿'
                }],
                c: null,
                platformIndex: 0,
                columnIndex: 0,
                id: '',
                showThird: true
            }
        },
        methods: {
            closePlatformAlertShow() {
                this.list.forEach((el,index) => {
                    el.alertShow = false;
                })
            },
            closeColumnAlertShow() {
                this.list[this.platformIndex].columns.forEach((el,index) => {
                    el.alertShow = false;
                })
            },
            open(res, c) {
                // let is_create = res ? 0 : 1
                let is_create = 1
                if(res && res != 'copy' && res != 'push'){
                    this.showThird = false
                }
                if(res == 'copy'){
                    is_create = 1
                }
                this.id = res || ''
                this.getPlatform(is_create)
                this.c = c;
                this.show = true;
            },
            close() {
                this.show = false;
                this.c(false)
            },
            addCount(platform_key) {
                if(platform_key == 'dy'){
                    let info = {};
                    common
                    .myFetch(apis.getDyUrl, info)
                    .then(r => {
                        if (r) {
                            console.log(r)
                            window.open(r.url)
                            // common.jump(r.url,true)
                        }
                    });
                    let config1 = {
                        title: '绑定完成前，请不要关闭此验证窗口<br>请在完成绑定后，依实际情况点击以下按钮',
                        content: '',
                        btn1: '绑定成功',
                        btn2: '暂不绑定',
                        showIcon: true,
                        showAlert: true
                    }

                    this.$MediaPlatformNotify(config1).then(e => {
                        // console.log(e)
                        if(e){
                            this.getPlatform(1)
                        }
                    })
                }else if(platform_key == 'bilibili'){
                    let info = {};
                    common
                    .myFetch(apis.getbiliurl, info)
                    .then(r => {
                        if (r) {
                            console.log(r)
                            window.open(r.url)
                            // common.jump(r.url,true)
                        }
                    });
                    let config1 = {
                        title: '绑定完成前，请不要关闭此验证窗口<br>请在完成绑定后，依实际情况点击以下按钮',
                        content: '',
                        btn1: '绑定成功',
                        btn2: '暂不绑定',
                        showIcon: true,
                        showAlert: true
                    }

                    this.$MediaPlatformNotify(config1).then(e => {
                        // console.log(e)
                        if(e){
                            this.getPlatform(1)
                        }
                    })
                }else{
                    this.$BPlus(platform_key).then(res => {
                        if(res) {
                            this.getPlatform(1)
                        }
                    }) 
                }
            },
            getPlatform(is_create) {
                try {
                    let id = ''
                    if(this.id == 'push' || this.id == 'copy'){
                        id = ''
                    }else{
                        id = this.id
                    }
                    let selectList = this.selectList
                    let info = {
                        is_create,
                        id: id
                    }
                    common
                    .myFetch(apis.newMediaPlatform, info)
                    .then(r => {
                        if (r) {
                            if(r.platforms.length > 0){
                                r.platforms.forEach((el,index) => {
                                    el.alertShow = false;
                                    el.columns.forEach(val => {
                                        val.alertShow = false;
                                        val.isSelect = false;
                                        val.typeList = [];
                                        val.typeList.push({
                                            isSelect: false,
                                            column_title: '视频稿'
                                        })
                                        val.typeList.push({
                                            isSelect: false,
                                            column_title: '图文稿'
                                        })
                                        if(val.selected){
                                            let name = r.platforms[index].platform_title+': '+val.column_title
                                            selectList.push({
                                                platform_key: r.platforms[index].platform_key,
                                                name: name,
                                                column_key: val.column_key,
                                                no: true
                                            })
                                            selectList = common.uniqObjInArrayName(selectList)
                                            this.selectList = selectList;
                                        }
                                    })
                                });
                                this.list = r.platforms
                                console.log(this.list)
                            }
                        }
                    });
                } catch (e) {
                    this.$toast('请联系管理员')
                }
            },
            createPlatform() {
                let submit_type = this.id ? 1 : 0
                if(this.selectList.length > 0){
                    let platforms = []
                    this.selectList.forEach(el => {
                        if(!this.showThird) {
                            platforms.push({
                                p_key: el.platform_key,
                                c_key: el.column_key,
                                // content_type: el.typeId
                            })
                        }else{
                            platforms.push({
                                p_key: el.platform_key,
                                c_key: el.column_key,
                                content_type: el.typeId
                            })
                        }
                    })

                    if(this.id == 'copy' || this.id == 'push'){
                        this.c(JSON.stringify(platforms))
                        this.close()
                    }else{
                        let info = {
                            platforms: JSON.stringify(platforms),
                            main_id: this.id,
                            submit_type: submit_type
                        };

                        common
                        .myFetch(apis.newMediaPlatformCreate, info)
                        .then(r => {
                            if (r) {
                                this.c(r.report_id)
                                this.close()
                            }
                        });
                    }

                }else{
                    this.$toast('请选择账号/栏目')
                }
            },
            selectItem(item) {
                console.log(this.id)
                if(item.selected || item.is_expire) return
                if(item.isSelect){
                    this.showType = false;
                    this.selectList = this.selectList.filter(el => {
                        return el.column_key != item.column_key
                    })
                }else{
                    let selectList = this.selectList
                    let typeName  = []
                    let typeId = []
                    if(!this.showThird){
                        let name = this.list[this.platformIndex].platform_title+': '+this.list[this.platformIndex].columns[this.columnIndex].column_title
                        selectList.push({
                            platform_key: this.list[this.platformIndex].platform_key,
                            name: name,
                            column_key: this.list[this.platformIndex].columns[this.columnIndex].column_key
                        })
                        selectList = common.uniqObjInArrayName(selectList)
                        this.selectList = selectList;
                        this.showType = true;
                    }else{
                        if(this.list[this.platformIndex].columns[this.columnIndex].content_type.length > 0){
                            this.list[this.platformIndex].columns[this.columnIndex].content_type.forEach(el => {
                                if(el.selected){
                                    typeName.push(el.content_title)
                                    typeId.push(el.content_id)
                                }
                            })
                        }
                        if(typeName.length > 0){
                            typeName = typeName.join('/')
                            typeId = typeId.join(',')
                            let name = this.list[this.platformIndex].platform_title+': '+this.list[this.platformIndex].columns[this.columnIndex].column_title+'('+typeName+')'
                            selectList.push({
                                platform_key: this.list[this.platformIndex].platform_key,
                                name: name,
                                column_key: this.list[this.platformIndex].columns[this.columnIndex].column_key,
                                typeId: typeId
                            })
                            selectList = common.uniqObjInArrayName(selectList)
                            this.selectList = selectList;
                        }
                        this.showType = true;
                    }
                }
                item.isSelect = !item.isSelect
            },
            selectPlatformItem(item,index) {
                this.platformIndex = index
                if(this.list[this.platformIndex].columns.length > 0){
                    if(this.list[this.platformIndex].columns[0].isSelect){
                        this.showType = true;
                    }else{
                        this.showType = false;
                    }
                }
            },
            selectColumnItem(item,index) {
                console.log(1,index)
                this.columnIndex = index;
                if(this.list[this.platformIndex].columns[index].isSelect){
                    this.showType = true;
                }else{
                    this.showType = false;
                }
            },
            selectTypeItem(item) {
                item.selected = !item.selected
                this.$nextTick(() => {
                    this.selectList = this.selectList.filter(el => {
                        return el.column_key != this.list[this.platformIndex].columns[this.columnIndex].column_key
                    })
                    let selectList = this.selectList
                    let typeName  = []
                    let typeId = []
                    if(this.list[this.platformIndex].columns[this.columnIndex].content_type.length > 0){
                        this.list[this.platformIndex].columns[this.columnIndex].content_type.forEach(el => {
                            if(el.selected){
                                typeName.push(el.content_title)
                                typeId.push(el.content_id)
                            }
                        })
                    }
                    if(typeName.length > 0){
                        typeName = typeName.join('/')
                        typeId = typeId.join(',')
                        let name = this.list[this.platformIndex].platform_title+': '+this.list[this.platformIndex].columns[this.columnIndex].column_title+'('+typeName+')'
                        selectList.push({
                            platform_key: this.list[this.platformIndex].platform_key,
                            name: name,
                            column_key: this.list[this.platformIndex].columns[this.columnIndex].column_key,
                            typeId: typeId
                        })
                        selectList = common.uniqObjInArrayName(selectList)
                        this.selectList = selectList;
                    }
                })
                
                // if(item.isSelect){
                //     this.selectList = this.selectList.filter(el => {
                //         return el.column_key != item.column_key
                //     })
                // }else{
                //     let name = this.list[this.platformIndex].platform_title+': '+item.column_title
                //     let selectList = this.selectList
                //     selectList.push({
                //         platform_key: this.list[this.platformIndex].platform_key,
                //         name: name,
                //         column_key: item.column_key
                //     })
                //     selectList = common.uniqObjInArrayName(selectList)
                //     this.selectList = selectList;
                // }
                
            },
            del(id) {
                this.selectList = this.selectList.filter(el => {
                    return el.column_key != id
                })

                this.list[this.platformIndex].columns.forEach(el => {
                    if(el.column_key == id){
                        el.isSelect = false
                    }
                })

                this.showType = false
            }
        },
        mounted() {
            
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000000;

    .box-container {
        width: 774px;
        padding: 20px 30px 24px;
        background: #F9F9F9;
        border-radius: 4px;
        box-sizing: border-box;

        &>.title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            p {
                font-size: 24px;
                color: #323B4B;
                line-height: 33px;
                font-weight: bold;
            }
        }

        .selected-container {
            display: flex;
            flex-direction: row;
            margin-bottom: 20px;

            .title {
                min-width: 39px;
                font-size: 13px;
                line-height: 18px;
                color: #666666;
                margin-right: 10px;
                font-weight: bold;
                box-sizing: border-box;
                padding-top: 6px;
            }

            ul {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                max-height: 70px;
                min-height: 40px;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    background: #ddd;
                    border-radius: 4px;
                }

                li {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    height: 30px;
                    line-height: 30px;
                    padding: 0 10px;
                    box-sizing: border-box;
                    border-radius: 4px;
                    background: rgba(185,195,195,0.2);
                    color: #323B4B;
                    margin: 0 10px 10px 0;
                    font-size: 14px;

                    span.un {
                        opacity: 0.4;
                    }

                    img {
                        width: 16px;
                        height: 16px;
                        margin-left: 16px;
                    }

                    &.un {
                        color: rgba(50, 59, 75, 0.2);

                        img {
                            display: none;
                        }
                    }
                }
            }
        }

        .line {
            width: 100%;
            height: 1px;
            background: #DCDCDC;
            margin-bottom: 19px;
        }

        .select-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            &>div {
                &:nth-last-of-type(1) {
                    margin: 0 0 0 3px;
                }
            }
            .left-container {
                // width: 236px;
                flex: 1;
                height: 289px;
                background: rgba(185, 195, 195, 0.15);
                border-radius: 4px;
                overflow: hidden;

                .title {
                    width: 100%;
                    height: 42px;
                    line-height: 42px;
                    background: #D5DEDB;
                    font-size: 13px;
                    color: #666666;
                    font-weight: bold;
                    text-align: center;
                }

                ul {
                    display: flex;
                    flex-direction: column;
                    height: calc(100% - 42px);
                    overflow-y: auto;
                    &::-webkit-scrollbar {
                        width: 6px;
                        height: 0;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: rgba(185, 195, 195, 0.5);
                        border-radius: 6px;
                    }

                    li {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        height: 42px;
                        line-height: 42px;
                        padding: 0 20px;
                        box-sizing: border-box;
                        user-select: none;
                        cursor: pointer;

                        &>div {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            .alert {
                                position: relative;
                                margin-right: 9px;

                                i {
                                    display: block;
                                    width: 14px;
                                    height: 14px;
                                    background: url('../../assets/img/mediaPublish/alertIcon.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                }

                                div {
                                    position: absolute;
                                    top: 20px;
                                    right: -20px;
                                    width: 148px;
                                    height: 32px;
                                    line-height: 32px;
                                    background: rgba(5, 15, 15, 0.8);
                                    border-radius: 4px;
                                    color: #FFF;
                                    font-size: 12px;
                                    text-align: center;
                                    display: flex;
                                    justify-content: center;
                                    
                                    em {
                                        font-size: 12px;
                                        color: @green;
                                        font-style: normal;
                                        text-decoration: underline;
                                        font-weight: bold;
                                    }
                                }
                            }
                        }

                        p {
                            font-size: 13px;
                            line-height: 18px;
                            color: #323B4B;
                            flex: 1;
                            min-width: 0;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                        }

                        i {
                            display: block;
                            width: 6px;
                            height: 10px;
                            background: url('../../assets/img/mediaPublish/angle.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                        }
                        
                        &:hover {
                            background: rgba(185, 195, 195, 0.15);
                            color: #41B48C;
                        
                            p {
                                color: #41B48C;
                            }
                        }

                        &.on {
                            background: rgba(185, 195, 195, 0.15);
                            p {
                                color: #41B48C;
                            }
                        }
                    }
                }
            }

            .middle-container {
                // width: 236px;
                flex: 1;
                height: 289px;
                background: rgba(185, 195, 195, 0.15);
                border-radius: 4px;
                overflow: hidden;
                margin: 0 3px;

                .title {
                    width: 100%;
                    height: 42px;
                    line-height: 42px;
                    background: #D5DEDB;
                    font-size: 13px;
                    color: #666666;
                    font-weight: bold;
                    text-align: center;
                }

                ul {
                    // display: flex;
                    // flex-direction: column;
                    height: calc(100% - 42px);
                    overflow-y: auto;
                    &::-webkit-scrollbar {
                        width: 6px;
                        height: 0;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: rgba(185, 195, 195, 0.5);
                        border-radius: 6px;
                    }

                    li {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        height: 42px;
                        min-height: 42px;
                        line-height: 42px;
                        padding: 0 20px;
                        box-sizing: border-box;
                        user-select: none;
                        cursor: pointer;

                        &:hover {
                            background: rgba(185, 195, 195, 0.15);
                        }

                        .alert {
                            position: relative;
                            margin-right: 9px;
                            margin-left: 6px;

                            i {
                                display: block;
                                width: 14px;
                                height: 14px;
                                background: url('../../assets/img/mediaPublish/alertIcon.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                border: none;
                            }

                            div {
                                position: absolute;
                                top: 20px;
                                left: -50px;
                                z-index: 9;
                                width: 148px;
                                height: 32px;
                                line-height: 32px;
                                background: rgba(5, 15, 15, 0.8);
                                border-radius: 4px;
                                color: #FFF;
                                font-size: 12px;
                                text-align: center;
                                display: flex;
                                justify-content: center;
                                
                                em {
                                    font-size: 12px;
                                    color: @green;
                                    font-style: normal;
                                    text-decoration: underline;
                                    font-weight: bold;
                                }
                            }
                        }

                        div {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            flex: 1;
                            min-width: 0;

                            &.grey {
                                p {
                                    color: rgba(50, 59, 75, 0.4);
                                }
                            }

                            i {
                                display: block;
                                width: 16px;
                                height: 16px;
                                border-radius: 50%;
                                // background: #FFF;
                                border: 1px solid #B9C3C3;
                                box-sizing: border-box;
                                margin-right: 14px;

                                &.un {
                                    width: 16px;
                                    height: 16px;
                                    background-color: #41B48C;
                                    border-radius: 8px;
                                    opacity: 0.4;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;
                                    background-image: url('../../assets/img/mediaPublish/pass.png');
                                    background-repeat: no-repeat;
                                    background-size: 12px 9px;
                                    background-position: center center;
                                }

                                &.on {
                                    width: 16px;
                                    height: 16px;
                                    background-color: #41B48C;
                                    border-radius: 8px;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;
                                    background-image: url('../../assets/img/mediaPublish/pass.png');
                                    background-repeat: no-repeat;
                                    background-size: 12px 9px;
                                    background-position: 50% 60%;
                                }

                                &.grey {
                                    width: 16px;
                                    height: 16px;
                                    background-color: transparent;
                                    border-radius: 8px;
                                    border: 1px solid rgba(185,195,195,0.5);
                                    box-sizing: border-box;
                                    color: rgba(50, 59, 75, 0.4);
                                }
                            }

                            p {
                                flex: 1;
                                min-width: 0;
                                font-size: 13px;
                                line-height: 18px;
                                color: #323B4B;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                white-space: nowrap;

                                &.un {
                                    color: rgba(50, 59, 75, 0.3);
                                }
                            }
                        }

                        &>i {
                            display: block;
                            width: 6px;
                            height: 10px;
                            background: url('../../assets/img/mediaPublish/angle.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;

                            &.un {
                                display: block;
                                width: 6px;
                                height: 10px;
                                background: url('../../assets/img/mediaPublish/angleUn.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                            }
                        }

                        &.on {
                            background: rgba(185, 195, 195, 0.15);
                            p {
                                color: #41B48C;
                            }
                        }
                    }
                }
            }

            .right-container {
                // width: 236px;
                flex: 1;
                height: 289px;
                background: rgba(185, 195, 195, 0.15);
                border-radius: 4px;
                overflow: hidden;
                margin: 0 !important;

                .title {
                    width: 100%;
                    height: 42px;
                    line-height: 42px;
                    background: #D5DEDB;
                    font-size: 13px;
                    color: #666666;
                    font-weight: bold;
                    text-align: center;
                }

                ul {
                    display: flex;
                    flex-direction: column;
                    height: calc(100% - 42px);
                    overflow-y: auto;
                    &::-webkit-scrollbar {
                        width: 6px;
                        height: 0;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: rgba(185, 195, 195, 0.5);
                        border-radius: 6px;
                    }

                    li {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        height: 42px;
                        line-height: 42px;
                        padding: 0 20px;
                        box-sizing: border-box;
                        user-select: none;
                        cursor: pointer;

                        &:hover {
                            background: rgba(185, 195, 195, 0.15);
                        }

                        i {
                            display: block;
                            width: 16px;
                            height: 16px;
                            border-radius: 50%;
                            // background: #FFF;
                            border: 1px solid #B9C3C3;
                            box-sizing: border-box;
                            margin-right: 14px;

                            &.un {
                                width: 16px;
                                height: 16px;
                                background-color: #41B48C;
                                border-radius: 8px;
                                opacity: 0.4;
                                border: 1px solid #41B48C;
                                box-sizing: border-box;
                                background-image: url('../../assets/img/mediaPublish/pass.png');
                                background-repeat: no-repeat;
                                background-size: 12px 9px;
                                background-position: center center;
                            }

                            &.on {
                                width: 16px;
                                height: 16px;
                                background-color: #41B48C;
                                border-radius: 8px;
                                border: 1px solid #41B48C;
                                box-sizing: border-box;
                                background-image: url('../../assets/img/mediaPublish/pass.png');
                                background-repeat: no-repeat;
                                background-size: 12px 9px;
                                background-position: 50% 60%;
                            }
                        }

                        p {
                            font-size: 13px;
                            line-height: 18px;
                            color: #323B4B;
                            flex: 1;
                            min-width: 0;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;

                            &.un {
                                color: rgba(50, 59, 75, 0.3);
                            }
                        }
                    }
                }
            }
        }

        .btns-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-top: 24px;

            .btn {
                width: 120px;
                height: 32px;
                background: #B9C3C3;
                border-radius: 4px;
                font-size: 14px;
                line-height: 32px;
                font-weight: bold;
                text-align: center;
                color: #FFF;
                user-select: none;
                cursor: pointer;

                &:hover {
                    .btnHover
                }

                &.on {
                    background: #41B48C;
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>